/* global $ */

import _ from '../Manager'
import app from '../App/App'
import html from './WeekBooking.html'
import Mustache from 'mustache'
import Page from '../Page'

class WeekBooking extends Page{
    id;
    currDay= new Date()
    toDay;

    constructor(){
        super()
        this.toDay= new Date()
        this.toDay.setDate( this.currDay.getDate() + 6 )
        this.refresh()
    }

    html(){
        return Mustache.render(html, {grid: this.renderGrid(), reservasCount: 0})
    }

    renderGrid(){
        let sesionesHtml=''
        for (let i=0; i < app.sesiones.length; i++) {
            sesionesHtml+=`<div>${app.sesiones[i].id}</div>`
        }

        let diasHtml=''
        for (let i=0; i < 7; i++ ) {
            let day= new Date()
            day.setDate( this.currDay.getDate() + i )
            let daystring= day.toLocaleString('default', {day:'numeric', month: 'short'}).toUpperCase()
                , daystring_wd= day.toLocaleString('default', {weekday: 'long'}).toUpperCase()
            let finde= day.getDay() == 0 || day.getDay() == 6 ? ' finde' : ''
            diasHtml+=`<div class="date_hd${finde}">
                <span>${daystring}</span>
                <span class="date_hd_wd">${daystring_wd}</span>
            </div>`
        }

        let contentHtml= ''

        return(`
        <div class="grid-container">
            <div class="grid-corner"></div>
            <div class="grid-colheader">${diasHtml}</div>
            <div class="grid-rowheader">${sesionesHtml}</div>
            <div id="_RESERVAS_" class="grid-content">${contentHtml}</div>
        </div>
        `)
    }

    formatDay( day ){
        return [
            day.toISOString().substring(0, 10)
            , day.toLocaleString('default', {weekday: 'long'}).toUpperCase()
        ]
    }

    refresh(){
        console.log('refreshing...', this.currDay.toISOString().substring(0, 10))
        _.request('eta-call', 'reservas_semanales', {
            diaDesde: this.currDay.toISOString().substring(0, 10)
            , diaHasta: this.toDay.toISOString().substring(0, 10)
        }).then( this.cargaReservas.bind(this) )
    }

    cargaReservas( reservas ){
        let reservasHtml= ''
        for(let d=0; d < 7; d++ ) {
            let day= new Date()
            day.setDate( this.currDay.getDate() + d )
            let finde= day.getDay() == 0 || day.getDay() == 6 ? ' finde' : ''
            for(let s= 0; s < app.sesiones.length; s++ ){
                let filtroReservas= reservas.filter( reserva =>
                    reserva.Time.substring(0,10) == day.toISOString().substring(0, 10) 
                    && reserva.Time.substring(11,16) == app.sesiones[s].id
                )
                if (filtroReservas.length){
                reservasHtml+= `<div class="cell ses${s} day${d}${finde}" onclick="_.returns('${day.toISOString().substring(0, 10)}')">
                        ${filtroReservas.length}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon" >
                            <path fill-rule="evenodd" d="M1.5 6.375c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v3.026a.75.75 0 01-.375.65 2.249 2.249 0 000 3.898.75.75 0 01.375.65v3.026c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 011.5 17.625v-3.026a.75.75 0 01.374-.65 2.249 2.249 0 000-3.898.75.75 0 01-.374-.65V6.375zm15-1.125a.75.75 0 01.75.75v.75a.75.75 0 01-1.5 0V6a.75.75 0 01.75-.75zm.75 4.5a.75.75 0 00-1.5 0v.75a.75.75 0 001.5 0v-.75zm-.75 3a.75.75 0 01.75.75v.75a.75.75 0 01-1.5 0v-.75a.75.75 0 01.75-.75zm.75 4.5a.75.75 0 00-1.5 0V18a.75.75 0 001.5 0v-.75zM6 12a.75.75 0 01.75-.75H12a.75.75 0 010 1.5H6.75A.75.75 0 016 12zm.75 2.25a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z" clip-rule="evenodd" />
                        </svg>
                    </div>`
                }
            }
        }
        let root=document.getElementById('_RESERVAS_')
        if (root) root.innerHTML= reservasHtml
        root=document.getElementById('_RESERVAS_COUNT_')
        if (root) root.innerHTML= ''+ reservas.length

    }


}

export default WeekBooking